// The three-step progress indicator for the public booking flow:
// 1 Choose · 2 Time · 3 Details. Implements: architecture.md v1.0 section 5.

import type { JSX } from 'react';

const STEPS = ['Choose', 'Time', 'Details'] as const;

export function Stepper({ current }: { current: 0 | 1 | 2 }): JSX.Element {
  return (
    <nav className="stepper" aria-label="Booking progress">
      {STEPS.map((label, i) => {
        const state = i < current ? 'is-done' : i === current ? 'is-active' : '';
        return (
          <span key={label} style={{ display: 'inline-flex', alignItems: 'center' }}>
            {i > 0 ? <span className="step-sep" aria-hidden="true" /> : null}
            <span className={`step ${state}`} aria-current={i === current ? 'step' : undefined}>
              <span className="step-dot">{i < current ? '✓' : i + 1}</span>
              <span className="step-label">{label}</span>
            </span>
          </span>
        );
      })}
    </nav>
  );
}
